import styles from './ModalWindow.module.css'
import React, {Children, ReactNode, useState} from "react";
import {useNavigate} from "react-router-dom";

interface ModalWindowCloseInt
{
    ():void
}
interface ModalWindowPropsInt
{
    onClose?:ModalWindowCloseInt
    children: ReactNode| undefined
}

function ModalWindow({children,onClose}:ModalWindowPropsInt)
{
    const [height] = useState(window.outerHeight)

    console.log(`height ${height}`)

    const navigate = useNavigate()
    const onCloseNav = ()=>{
        if(onClose) onClose()
    }

    const handleClick = (e:any) => {
        console.log(e.target.id);
        if(e?.target?.id ==="modalCenteredWindow")onCloseNav()
    };
    return (
        <div >
            <div className={styles.darkBG} onClick={()=>{onCloseNav()}} style={{height:`${height}px`}}></div>
            <div id={"modalCenteredWindow"} className={styles.centered } onClick={(e)=>handleClick(e)}>
                {children}
            </div>
        </div>

    )
}

export default ModalWindow;